import bs58 from 'bs58';

import { WalletBase } from '../WalletBase';
import { ISignResult } from '../types';

export class PhantomWallet extends WalletBase {
  authType = 'Phantom';
  init(): void {
    if ('phantom' in window) {
      const provider = window.phantom?.solana;

      if (provider?.isPhantom) {
        this.provider = provider;
      }
    } else {
      window.open('https://phantom.app/', '_blank');
    }
  }

  async connect(): Promise<boolean> {
    const provider = this.provider; // see "Detecting the Provider"
    if (!provider) return false;
    try {
      const resp = await provider.connect();
      this.isConnected = true;
      this.publicKey = resp.publicKey.toString();
      console.log(resp, resp.publicKey.toString());
      return true;
    } catch (err) {
      // { code: 4001, message: 'User rejected the request.' }
      return false;
    }
  }
  async sign(message: string): Promise<ISignResult> {
    const provider = this.provider;
    const encodedMessage = new TextEncoder().encode(message);
    const signedMessage = await provider.signMessage(encodedMessage, 'utf8');

    return {
      message,
      signature: bs58.encode(signedMessage.signature)
    };
  }
}
